var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeavInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3295 12.3829L13.968 18.4401C13.38 19.0001 12.4275 19.0001 11.8395 18.4401L8.661 15.4129C8.0745 14.8558 8.0745 13.9515 8.661 13.3929C9.246 12.8358 10.197 12.8358 10.782 13.3929L11.844 14.4043C12.429 14.9615 13.3785 14.9615 13.965 14.4043L18.2085 10.3629C18.7935 9.80435 19.743 9.80435 20.3295 10.3629C20.916 10.9201 20.916 11.8244 20.3295 12.3829ZM27 0.714355H3C1.3425 0.714355 0 1.99293 0 3.5715V26.4286C0 28.0058 1.3425 29.2858 3 29.2858H27C28.6575 29.2858 30 28.0058 30 26.4286V3.5715C30 1.99293 28.6575 0.714355 27 0.714355Z",
    fill: "#24A36C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavInfo2);
export default __webpack_public_path__ + "static/media/leav-info-2.921d2593e359b1f608bde0761cdeb231.svg";
export { ForwardRef as ReactComponent };